import React from "react";
import { Link } from "react-router-dom";
import MarketingPageLayout, { PolicySection } from "@/components/marketing/MarketingPageLayout";

export default function DisputeResolutionPolicy() {
  return (
    <MarketingPageLayout
      eyebrow="Compliance"
      title="Dispute Resolution Policy"
      subtitle="The independent process by which guests can challenge a record about them — and how operators can challenge each other."
      lastUpdated="February 2026"
      path="/dispute-resolution"
      seoDescription="The independent appeal and dispute process for guests and operators on the GuestIntel network — timelines, outcomes, and escalation paths."
    >
      <PolicySection title="1. Right of appeal">
        <p>
          Anyone with a record on the GuestIntel network has the right to appeal. Appeals are free, do not
          require an account, and are handled by case managers independent of the submitting property.
        </p>
      </PolicySection>

      <PolicySection title="2. How to appeal">
        <ol>
          <li>Visit the public <Link to="/appeal">Appeal Portal</Link>.</li>
          <li>Provide your name, contact details, and the record identifier (if known).</li>
          <li>Describe the grounds — factual error, mistaken identity, resolved dispute, etc.</li>
          <li>Attach supporting documents (receipts, communications, police reports).</li>
          <li>You'll get an appeal ID and an email acknowledgement within 24 hours.</li>
        </ol>
      </PolicySection>

      <PolicySection title="3. Timeline">
        <ul>
          <li>Acknowledgement: within 1 business day.</li>
          <li>Initial decision: within 14 business days for standard appeals; 21 for complex cases.</li>
          <li>Independent escalation: within 30 business days for contested decisions.</li>
        </ul>
      </PolicySection>

      <PolicySection title="4. Outcomes">
        <ul>
          <li><strong>Upheld</strong> — the record is annotated with an "appealed and upheld" badge; no other change.</li>
          <li><strong>Amended</strong> — fields are corrected (severity, description) per the evidence.</li>
          <li><strong>Withdrawn</strong> — the record is removed from cross-tenant lookup and anonymised per the <Link to="/data-retention">Data Retention Policy</Link>.</li>
        </ul>
      </PolicySection>

      <PolicySection title="5. Operator disputes">
        <p>
          When two participating properties disagree about a record (duplicates, overlapping incidents,
          severity calibration), the case manager facilitates an evidence-based resolution. Persistent
          patterns trigger a review-board hearing.
        </p>
      </PolicySection>

      <PolicySection title="6. No retaliation">
        <p>
          Operators must not retaliate against a guest for filing an appeal. Retaliation is a Terms-of-
          Service violation and triggers tenant review under the{" "}
          <Link to="/terms">Terms of Service</Link>.
        </p>
      </PolicySection>

      <PolicySection title="7. Contact">
        <p>
          Reach the appeals team directly at <a href="mailto:appeals@guestintel.net">appeals@guestintel.net</a> if you can't access the portal.
        </p>
      </PolicySection>
    </MarketingPageLayout>
  );
}
